import { usePermissions } from '../context/PermissionContext';
import { useAuth } from '../context/AuthContext';

/**
 * Hook to check permissions for the current user
 * @param {string|string[]} permission - Single permission or array of permissions
 * @param {string} mode - 'any' or 'all' for array permissions
 * @returns {boolean} - Whether user has the permission(s)
 */
export const usePermission = (permission, mode = 'any') => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();
  const { user } = useAuth();

  // Admin always has all permissions
  if (user?.role === 'admin') {
    return true;
  }

  if (Array.isArray(permission)) {
    return mode === 'all'
      ? hasAllPermissions(permission)
      : hasAnyPermission(permission);
  }

  return hasPermission(permission);
};

export default usePermission;
